<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <router-link
        v-for="tag in visitedViews"
        v-show="!tag.meta.hiddenTag"
        ref="tag"
        :key="tag.path"
        :class="isActive(tag) ? 'active' : ''"
        :to="{ path: tag.path, query: tag.query ? { ...tag.query, switch: true } : { switch: true }, fullPath: tag.fullPath }"
        tag="span"
        class="tags-view-item"
        @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        <span class="tagTitle" @click="handleActiveCookie(tag)">{{ tag.title }}</span>
        <!-- <el-tooltip class="item" effect="dark" placement="top-start">
          <span slot="content">{{ tag.title }}</span> -->

        <!-- </el-tooltip> -->
        <span
          v-if="!isAffix(tag)"
          class="el-icon-close"
          style="display: inline-block"
          @click.prevent.stop="closeSelectedTag(tag)"
        />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{ left: `${left}px`, top: `${top}px` }" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">刷新</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">关闭</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from "./ScrollPane";
import { checkIsMircApp } from "@/utils/mircApp";
import { _local, ActiveKey } from "@/utils/storage";
import path from "path";

export default {
  name: "TagsView",
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      stateEvent: {
        event: -1,
        tags: []
      }
    };
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    },
    routes() {
      return this.$store.state.permission.routes;
    }
  },
  watch: {
    $route() {
      this.addTags();
      this.moveToCurrentTag();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    }
  },
  mounted() {
    this.initTags();
    this.addTags();
  },
  methods: {
    isActive(route) {
      const flag = route.path === this.$route.path || route.path === this.$route.meta.tagReplace;
      if (flag) {
        this.$store.dispatch("tagsView/setCurrentTag", route);
      }
      return flag;
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix;
    },
    filterAffixTags(routes, basePath = "/") {
      let tags = [];
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          });
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path);
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags];
          }
        }
      });
      return tags;
    },
    initTags() {
      const affixTags = (this.affixTags = this.filterAffixTags(this.routes));
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch("tagsView/addVisitedView", tag);
        }
      }
    },
    addTags() {
      this.$route.meta.keepAlive = true;
      const { path, fullPath } = this.$route;
      if (checkIsMircApp(path)) {
        setTimeout(() => {
          // 第一次打开的时候需要把之前未通知到子应用的数据传过去。包括、关闭、关闭其他、关闭所有。刷新忽略
          let event = 0; // 0--新增， 2--刷新（先清除缓存再存储）
          switch (this.stateEvent.event) {
            case 1:
              {
                const { tags } = this.stateEvent;
                tags.forEach(element => {
                  if (element === path) {
                    event = 2;
                  } else {
                    this.$actions.setGlobalState({
                      event: 1,
                      path: element
                    });
                  }
                });
              }
              break;
            case 3:
              this.$actions.setGlobalState({
                event: 3,
                reSetList: []
              });
              break;
            default:
              break;
          }
          this.stateEvent.event = -1;
          this.stateEvent.tags = [];
          this.$actions.setGlobalState({
            event,
            path
          });
        }, 1000);
      }

      const { name } = this.$route;
      if (name) {
        this.$store.dispatch("tagsView/addView", this.$route);
      }
      return false;
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag);
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch("tagsView/updateVisitedView", this.$route);
            }
            break;
          }
        }
      });
    },
    refreshSelectedTag(view) {
      if (checkIsMircApp(view.path)) {
        this.$actions.setGlobalState({
          event: 2,
          path: view.path
        });
      } else {
        this.$store.dispatch("tagsView/delCachedView", view).then(() => {
          // const { fullPath } = view;
          this.$nextTick(() => {
            this.$router.replace({
              path: `/redirect${view.fullPath}`
            });
          });
        });
      }
    },
    closeSelectedTag(view) {
      // 将路由中的keepAlive设置为false
      this.$route.meta.keepAlive = false;
      const { path: viewPath } = view;
      if (checkIsMircApp(viewPath)) {
        const activeMircApp = checkIsMircApp(this.$route.path);
        if (activeMircApp) {
          this.$actions.setGlobalState({
            event: 1,
            path: viewPath
          });
        }
        this.stateEvent.event = 1;
        this.stateEvent.tags.push(viewPath);
      }

      this.$store.dispatch("tagsView/delView", view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view);
        }
      });
    },
    closeOthersTags() {
      const { path } = this.selectedTag;
      if (checkIsMircApp(path)) {
        this.$actions.setGlobalState({
          event: 3,
          reSetList: [path]
        });
      } else {
        this.stateEvent.event = 3;
        this.stateEvent.tags = [];
      }
      this.$router.push(this.selectedTag);
      this.$store.dispatch("tagsView/delOthersViews", this.selectedTag).then(() => {
        this.moveToCurrentTag();
      });
    },
    closeAllTags(view) {
      const activeMircApp = checkIsMircApp(this.$route.path);
      if (activeMircApp) {
        this.$actions.setGlobalState({
          event: 3,
          reSetList: []
        });
      } else {
        this.stateEvent.event = 3;
        this.stateEvent.tags = [];
      }

      this.$store.dispatch("tagsView/delAllViews").then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return;
        }
        this.toLastView(visitedViews, view);
      });
    },
    toLastView(visitedViews, view) {
      const [latestView] = visitedViews.slice(-1);
      if (latestView) {
        _local.set(ActiveKey, { path: latestView.path });
        this.$router.push(latestView.fullPath);
        return;
      }
      if (view.name === "Dashboard") {
        // to reload home page
        this.$router.replace({ path: `/redirect${view.fullPath}` });
        return;
      }

      this.$router.push("/");
    },
    openMenu(tag, e) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const { offsetWidth } = this.$el; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX - offsetLeft + 15; // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      // this.top = e.clientY
      this.top = "34";
      this.visible = true;
      this.selectedTag = tag;
    },
    closeMenu() {
      this.visible = false;
    },
    handleScroll() {
      this.closeMenu();
    },
    handleActiveCookie(tag) {
      tag && _local.set(ActiveKey, { path: tag.path });
    }
  }
};
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 40px;
  width: 100%;
  z-index: 99;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 2px 4px 0 rgba(33, 37, 46, 0.1);
  position: relative;

  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 26px;
      line-height: 24px;
      border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 8px;
      margin-top: 6px;
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        background-color: #00B259;
        color: #fff;
        border-color: #00B259;
      }
      &:hover {
        max-width: auto;
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
//reset element css of el-icon-close
.tags-view-container {
  .tags-view-wrapper {
    .tags-view-item.active,
    .tags-view-item {
      .el-icon-close {
        color: #fff;
        width: 16px;
        height: 16px;
        vertical-align: 10px;
        border-radius: 50%;
        text-align: center;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        transform-origin: 100% 50%;
        margin-left: 4px;

        &:before {
          transform: scale(0.8);
          display: inline-block;
          vertical-align: -3px;
          color: #fff;
        }
        &:hover {
          background-color: #fff;
          color: #fff;
          &:before {
            color: #00b259;
          }
        }
      }
      .tagTitle {
        max-width: 10em;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
    }
  }
}
.tags-view-container {
  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        &:before {
          color: #505363;
        }
        &:hover {
          background-color: #9ea5b2;
          &:before {
            color: #fff;
          }
        }
      }
      &:hover {
        border: 1px solid #00b259;
      }
    }
  }
}
.el-tabs__item .el-icon-close:hover {
  background-color: #c6ccd7;
}
</style>
